import { snapToGrid } from "../PositionedHooks/dragUtils";
import { keyToDirection } from "../KeyboardHandler/keyboardHandlerUtils";

export function getGuidelineData(e, containerRect, dragOffset, draggedItem, correctionFactor, gridSize) {
  const left = snapToGrid(correctionFactor * (e.clientX - dragOffset.x - containerRect.left), gridSize);
  const top = snapToGrid(correctionFactor * (e.clientY - dragOffset.y - containerRect.top), gridSize);
  const bottom =
    snapToGrid(correctionFactor * (e.clientY - dragOffset.y - containerRect.top), gridSize) +
    parseInt(draggedItem.style.height);
  const right =
    snapToGrid(correctionFactor * (e.clientX - dragOffset.x - containerRect.left), gridSize) +
    parseInt(draggedItem.style.width);
  return { left, top, bottom, right };
}

export const showGuidelineForElementMove = (
  element,
  key,
  isResize = false,
  { containerRef, elementRefs, gridSize, screenWidth, setGuidlineData, guidelineTimeoutRef }
) => {
  if (!element) return;
  if (element.type === "section") return;
  const containerRect = containerRef.current.getBoundingClientRect();
  const correctionFactor = screenWidth / containerRect.width;

  // const calculatedGuideLine = generateGuideLineWhenMoveWithKeyboard(
  //   element,
  //   elementRefs,
  //   gridSize,
  //   containerRect,
  //   correctionFactor,
  //   keyToDirection[key],
  //   isResize
  // );
  const rect = elementRefs.current[element.id]?.current?.getBoundingClientRect();
  const calculatedGuideLine = generateGuideLineWhenMoveWithKeyboard(
    element,
    {
      left: rect.left,
      top: rect.top,
      width: rect.width,
      height: rect.height
    },
    gridSize,
    containerRect,
    correctionFactor,
    keyToDirection[key],
    isResize
  );
  setGuidlineData(calculatedGuideLine);

  // Clear previous timeout
  if (guidelineTimeoutRef.current) clearTimeout(guidelineTimeoutRef.current);

  // Auto-clear after 700ms
  guidelineTimeoutRef.current = setTimeout(() => {
    setGuidlineData(null);
  }, 700);
};

export const generateGuideLineWhenMoveWithKeyboard = (
  element,
  { left, top, width, height }, // only rect values
  gridSize,
  containerRect,
  correctionFactor,
  direction,
  isResize = false
) => {
  let dragOffset = { x: 0, y: 0 };

  if (isResize) {
    switch (direction) {
      case "right":
        dragOffset.x = 0;
        element.style.width = `${width + gridSize}px`;
        break;
      case "left":
        dragOffset.x = 0;
        element.style.width = `${width - gridSize}px`;
        break;
      case "down":
        dragOffset.y = 0;
        element.style.height = `${height + gridSize}px`;
        break;
      case "up":
        dragOffset.y = 0;
        element.style.height = `${height - gridSize}px`;
        break;
    }
  } else {
    switch (direction) {
      case "left":
        dragOffset.x = gridSize;
        break;
      case "right":
        dragOffset.x = -gridSize;
        break;
      case "up":
        dragOffset.y = gridSize;
        break;
      case "down":
        dragOffset.y = -gridSize;
        break;
    }
  }

  return getGuidelineData(
    { clientX: left, clientY: top }, // mimic mouse event
    containerRect,
    dragOffset,
    element,
    correctionFactor,
    gridSize
  );
};
